import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TabsLayoutComponent } from 'app/shared/components/organisms';
import { MessagesListComponent } from '../messages-list/messages-list.component';

@Component({
  selector: 'app-messages-overview',
  imports: [TabsLayoutComponent],
  templateUrl: './messages-overview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagesOverviewComponent {
  private readonly translate = inject(TranslateService);
  public tabs = [
    {
      component: MessagesListComponent,
      title: this.translate.instant('messages.tabs.group'),
      disabled: false,
    },
    {
      component: MessagesListComponent,
      title: this.translate.instant('messages.tabs.private'),
    },
  ];
}
